export enum ExternalDataFeeTypeEnum {
  UP = 'UP',
  DOWN = 'DOWN',
}
